<template>
  <div class="hc-rubric">
    <div
      v-if="props.rubric.title"
      class="hc-rubric__title"
    >
      {{ props.rubric.title }}
    </div>
    <div
      v-for="question in props.rubric.questions"
      :key="question.id"
      class="hc-rubric__question"
      @click="goToArticle(question.id.toString())"
    >
      {{ question.question }}
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { HelpCenterRubric } from '@/shared/api/helpCenter';
  import { useStaticBasePath } from '@/shared/lib/useStaticBasePath';

  interface IProps {
    rubric: HelpCenterRubric;
    sectionSlug: string;
  }

  const props = defineProps<IProps>();
  const router = useRouter();
  const staticPath = useStaticBasePath();

  const goToArticle = (elId?: string) => {
    router.push(`${staticPath}/${props.sectionSlug}/${props.rubric.slug}#${elId ? elId : ''}`);
  };
</script>

<style scoped lang="scss">
  .hc-rubric {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @include adaptivity.tablet {
      gap: 12px;
    }
  }

  .hc-rubric__title {
    @include typography.base-400-400-semi;

    @include adaptivity.tablet {
      @include typography.base-400-300-semi;
    }
  }

  .hc-rubric__question {
    cursor: pointer;

    @include typography.base-400-400-regular;
  }
</style>
